import React from 'react';
import { RedirectIcon } from 'assets/icons/RedirectIcon';
import styles from './styles.module.scss';

export const Redirect = () => (
  <div className={styles.cartIcon}>
    <RedirectIcon white />
  </div>
);
